import type { ChannelDescriptor } from '@centrali/fdc3'

/**
 * The FDC3 recommended 8-colour User channel set (Spec 008 §6, §9.1).
 *
 * Ids follow the `fdc3.channel.N` convention. Colours/labels are the host's
 * display metadata for the channel selector chrome.
 */
export const USER_CHANNELS: ChannelDescriptor[] = [
  { id: 'fdc3.channel.1', type: 'user', displayMetadata: { name: 'Red', color: '#D32F2F' } },
  { id: 'fdc3.channel.2', type: 'user', displayMetadata: { name: 'Orange', color: '#F57C00' } },
  { id: 'fdc3.channel.3', type: 'user', displayMetadata: { name: 'Yellow', color: '#FBC02D' } },
  { id: 'fdc3.channel.4', type: 'user', displayMetadata: { name: 'Green', color: '#388E3C' } },
  { id: 'fdc3.channel.5', type: 'user', displayMetadata: { name: 'Cyan', color: '#0097A7' } },
  { id: 'fdc3.channel.6', type: 'user', displayMetadata: { name: 'Blue', color: '#1976D2' } },
  { id: 'fdc3.channel.7', type: 'user', displayMetadata: { name: 'Magenta', color: '#C2185B' } },
  { id: 'fdc3.channel.8', type: 'user', displayMetadata: { name: 'Purple', color: '#7B1FA2' } }
]

const USER_CHANNEL_IDS = new Set(USER_CHANNELS.map((c) => c.id))

export function isUserChannelId(id: string): boolean {
  return USER_CHANNEL_IDS.has(id)
}

export function getUserChannel(id: string): ChannelDescriptor | undefined {
  return USER_CHANNELS.find((c) => c.id === id)
}
